module.exports = __webpack_public_path__ + "static/media/GXP1628_large.64f0c07e.png";